import type { Quiz, QuizEntities, QuizIds } from 'features/quizzes/types';

export const normalizeQuizzes = (
  quizzes: Quiz[]
): {
  entities: QuizEntities;
  ids: QuizIds;
  activeQuizId: string | null;
  activeQuizSessionId: string | null;
} => {
  const entities: QuizEntities = {};
  const ids: QuizIds = [];
  let activeQuizId: string | null = null;
  let activeQuizSessionId: string | null = null;

  for (const quiz of quizzes) {
    entities[quiz.id] = quiz;
    ids.push(quiz.id);

    if (quiz.status === 'launched') {
      activeQuizId = quiz.id;
      activeQuizSessionId = quiz.sessionId;
    }
  }

  return {
    entities,
    ids,
    activeQuizId,
    activeQuizSessionId,
  };
};
